import React from 'react';
import Editor from '@monaco-editor/react';
import { formilyReact } from '@alife/cn-ui';
// import "./format-result-form.scss"

var observer = formilyReact.observer;
var FormatResultForm = observer(function (props) {
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Editor, {
    height: '120px',
    defaultLanguage: "javascript",
    className: 'formatResultContainer',
    value: props.value,
    onChange: props.onChange
  }));
});
export default FormatResultForm;